import { Link } from 'expo-router'
import { useTranslation } from 'react-i18next'
import { Linking, Pressable, View, useWindowDimensions } from 'react-native'
import { Icon } from '@/components/ui/Icon'
import { Text } from '@/components/ui/Text'
import { useTheme } from '@/contexts/ThemeContext'

function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export default function Footer({
  floating,
  showTermsLink = false,
}: {
  floating?: boolean
  showTermsLink?: boolean
}) {
  const { colors } = useTheme()
  const { t } = useTranslation()
  const { width } = useWindowDimensions()
  const isSmall = width < 480

  return (
    <View
      className="w-full border-t"
      style={
        floating
          ? {
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              marginTop: 22,
              backgroundColor: hexToRgba(colors.surface, 0.5),
              borderColor: colors.border,
            }
          : {
              marginTop: 22,
              backgroundColor: colors.background,
              borderColor: colors.border,
            }
      }
    >
      <View className="p-3">
        <View className="mb-3 flex-row items-center justify-between">
          <View className="flex-row items-center">
            <Link href="/about" className="mr-5 flex-row items-center">
              <Icon name="angle-right" size={14} color={colors.primary} />
              <Text className="ml-1 text-sm" style={{ color: colors.dark }}>
                {t('footer.about')}
              </Text>
            </Link>
            {showTermsLink ? (
              <Link href="/terms" className="mr-5 flex-row items-center">
                <Icon name="angle-right" size={14} color={colors.primary} />
                <Text className="ml-1 text-sm" style={{ color: colors.dark }}>
                  {t('footer.terms')}
                </Text>
              </Link>
            ) : null}
            <Link href="/privacy" className="flex-row items-center">
              <Icon name="angle-right" size={14} color={colors.primary} />
              <Text className="ml-1 text-sm" style={{ color: colors.dark }}>
                {t('footer.privacy')}
              </Text>
            </Link>
          </View>
          <Pressable className="flex-row items-center gap-4" style={{ gap: 16 }}>
            <Pressable
              className="flex-row items-center"
              onPress={() => Linking.openURL('https://www.youtube.com/@otrosmeridianos')}
            >
              <Icon name="youtube-play" size={15} color={colors.primary} />
              {!isSmall && (
                <Text className="ml-1 text-sm" style={{ color: colors.dark }}>
                  {t('footer.youtube')}
                </Text>
              )}
            </Pressable>
            <Pressable
              className="flex-row items-center"
              onPress={() => Linking.openURL('https://www.instagram.com/otrosmeridianos/')}
            >
              <Icon name="instagram" size={15} color={colors.primary} />
              {!isSmall && (
                <Text className="ml-1 text-sm" style={{ color: colors.dark }}>
                  {t('footer.instagram')}
                </Text>
              )}
            </Pressable>
          </Pressable>
        </View>
      </View>
    </View>
  )
}
